import { render, staticRenderFns } from "./VisualRanking.vue?vue&type=template&id=17a74261&scoped=true&"
import script from "./VisualRanking.vue?vue&type=script&lang=js&"
export * from "./VisualRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a74261",
  null
  
)

export default component.exports